import * as util from "./modules/_register-utils.js";
import { segmentedProfessions } from './modules/segmented-professions';
import * as submission from './modules/_submission';

// Get all of the professions
// let professionsArray = []
// professions.map((profession) => {
//     let obj = {}
//     obj.value = profession.value
//     obj.name = profession.text
//     obj.text = profession.text
//     professionsArray.push(obj)

//     // console.log(professions)
// })

// Get all of the expertises
let expertisesArray = []
expertises.map((expertise) => {
    let obj = {}
    obj.value = expertise.id
    obj.name = expertise.name
    obj.text = expertise.name
    obj.professionIds = expertise.professionIds
    obj.abbreviation = expertise.abbreviation
    expertisesArray.push(obj)
})


// If the get started button exists, bind a click event to it and check the inputted email
if (document.querySelector('#register--check button')) {
    document.querySelector('#register--check button').addEventListener('click', util.checkEmail)
}




document.addEventListener('DOMContentLoaded', function () {

    // v1.2
    // Setup the getCookie function to grab the cookie from the browser.
    window.getCookie = function (name) {
        var match = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'));
        if (match) return match[2];
    };

    // Use getCookie to grab the 'hubspotutk' value from the browser.
    var hubSpotUtkCookie = getCookie('hubspotutk');    

    // We need to manually format the phone number on page load
    document.getElementById('phone').value = util.phoneFormat(document.getElementById('phone').value);

    // Format the phone number as the user types it
    document.getElementById('phone').addEventListener('keyup', function (evt) {
        var phone = document.getElementById('phone');
        var charCode = (evt.which) ? evt.which : evt.keyCode;
        phone.value = util.phoneFormat(phone.value);
    });

    // Check for password requirements
    document.getElementById('password').addEventListener('keyup', function (evt) {
        util.checkPassword();
    });
    document.getElementById('password').addEventListener('focus', function (evt) {
        util.checkPassword();
    });

    // We need to manually format the zip code on page load
    document.getElementById('zipCode').value = util.zipCodeFormat(
        document.getElementById('country').value,
        document.getElementById('zipCode').value
    );

    if (document.getElementById('country').value) {
        document.getElementById('zipCode').removeAttribute('disabled')
    }

    // Format the zip code as the user types it
    document.getElementById("zipCode").addEventListener('keyup', function (evt) {
        var country = document.getElementById("country");
        evt.target.value = util.zipCodeFormat(country.value, evt.target.value)
    })


    // Only allow submissions if user accepts terms
    document.getElementById("hasAcceptedLatestTerms").addEventListener('change', function (evt) {
        var submitButton = document.querySelector('.submit button');
        if (this.checked) {
            submitButton.disabled = false;
        } else {
            submitButton.disabled = true;
        }
    })



    // Only allow first step of reg if checkbox is selected
    if (document.getElementById("initialAcceptance")) {
        document.getElementById("initialAcceptance").addEventListener('change', function (evt) {
        var initialSubmitButton = document.getElementById('applynow');
        var submitButton = document.querySelector('#register-form #submit-button');
        if (this.checked) {
            initialSubmitButton.disabled = false;
            submitButton.disabled = false;
        } else {
            initialSubmitButton.disabled = true;
            submitButton.disabled = true;
        }
        })
    }   


    // Record hasAcceptedOptInText
    if (document.getElementById('hasAcceptedOptInTextInitial')) {
        document.getElementById('hasAcceptedOptInTextInitial').addEventListener('change', function (evt) {
            if (this.checked) {
                document.getElementById('hasAcceptedOptInText').checked = true;
            } else {
                document.getElementById('hasAcceptedOptInText').checked = false;
            }
        })
    }



    segmentedProfessions();

    // Initialize experience dropdown
    jQuery('.experience-dropdown').dropdown();

    // Initialize the search specialties dropdown
    jQuery('.specialties-dropdown').dropdown({
        fullTextSearch: false,
        onChange: function(value, text, $selectedItem) {
            var isLocumsForm = sessionStorage.getItem("isLocums");
            if (document.getElementById('specialty[][expertiseName]') && isLocumsForm == "true") {
                let abbreviation = expertisesArray.filter(obj => {
                    return obj.value === parseInt(value)
                });
            
                document.getElementById('specialty[][expertiseName]').value = abbreviation[0].abbreviation
            } 
            else {
                document.getElementById('specialty[][expertiseName]').value = value
            }
        }
    });

    // Initialize the search expertise dropdown
    // jQuery('.expertise-dropdown').dropdown({
    //     fullTextSearch: false,
        
    // });

    // Initialize country dropdown
    jQuery('.country-dropdown').dropdown({
        fullTextSearch: false,
        onChange: function(value, text, $selectedItem) {
            var zipCodeElement = document.getElementById('zipCode')

            if (zipCodeElement && value !== '') {
                zipCodeElement.removeAttribute('disabled');
                zipCodeElement.value = '';
            }
        }
    });

    // Initialize the search professions dropdown

    jQuery('.professions-dropdown').dropdown({
        fullTextSearch: false,
        action: 'activate',
        onChange: function(value, text, $selectedItem) {
            
            jQuery('.specialties-dropdown').removeClass('disabled');
            jQuery('[data-input="expertiseCode"]').val('');
            jQuery('[data-input="expertiseName"]').val('');
         
        },
        onRemove: function(removedValue, removedText, $removedChoice) {
            
            jQuery('.specialties-dropdown').dropdown('clear');
            jQuery('.specialties-dropdown').addClass('disabled');

        }
    });








  
      // Hook up the form so we can prevent it from being posted
      var form = document.querySelector("form#register-form");
      form.addEventListener("submit", function(ev) {
        ev.preventDefault();
        submission.handleFormSubmit(form);
      });
})
